import React from 'react';
import { Box, Skeleton } from '@mui/material';

function SkeletonForm({ fields = [{ height: 56 }, { height: 200 }, { height: 400 }] }) {
    return (
        <Box>
            {fields.map((field, index) => (
                <Skeleton 
                    key={index}
                    variant="rectangular" 
                    height={field.height} 
                    sx={{ mb: 3 }} 
                    width={field.width || '100%'}
                />
            ))}
        </Box>
    );
}

export default SkeletonForm;

